<template>
  <div class="container">
    <form autocomplete="off" @submit.prevent="handleSubmit">
      <div class="row">
        <span class="separador"></span>
        <div class="col-xs-12">
          <h3>Indicanos quién es el interesado</h3>
          <div class="opciones horizontal">
            <div class="radio">
              <input name="tipo" type="radio" value="empresa" v-model="user.tipo">
              <label>
                <span class="radio-custom"></span> 
                <span>Empresa</span>
              </label>
            </div>
            <div class="radio">
              <input name="tipo" type="radio" value="persona" v-model="user.tipo">
              <label>
                <span class="radio-custom"></span>
                <span>Persona Física</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <span class="separador"></span>
        <div id="scroll"></div>
        <div class="col-xs-12" v-if="user.tipo === 'persona'">
          <h3 v-if="user.tipo === 'empresa'">Cantidad de unidades a comprar</h3>
          <h3 v-if="user.tipo === 'persona'">Seleccione una opción</h3>
        </div>
        <div class="col-xs-12" v-if="user.tipo === 'persona'">
          <div v-if="user.tipo === 'empresa'" class="opciones horizontal">
            <div class="radio">
              <input name="adicional" type="radio" value="Menos de 5 unidades" v-model="user.adicional">
              <label>
                <span class="radio-custom"></span> 
                <span>Menos de 5 unidades</span>
              </label>
            </div>
            <div class="radio">
              <input name="adicional" type="radio" value="5 unidades o más" v-model="user.adicional">
              <label>
                <span class="radio-custom"></span>
                <span>5 unidades o más</span>
              </label>
            </div>
          </div>
          <div v-if="user.tipo === 'persona'" class="opciones horizontal">
            <div class="radio">
              <input name="adicional" type="radio" value="Persona con discapacidad" v-model="user.adicional">
              <label>
                <span class="radio-custom"></span> 
                <span>Persona con discapacidad</span>
              </label>
            </div>
            <div class="radio">
              <input name="adicional" type="radio" value="Diplomático" v-model="user.adicional">
              <label>
                <span class="radio-custom"></span>
                <span>Diplomático</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <span class="separador"></span>
        <div class="col-xs-12">
          <h3>Tus datos de contacto</h3>
        </div>
        <div class="form-group col-md-4" :class="{'has-error' : errors.has('name'), 'has-success' : fields.name && fields.name.valid }">
          <float-label>
            <input
              type="text"
              name="name"
              id="name"
              class="form-control efecto"
              placeholder="Nombre"
              v-model="user.nombre"
              v-validate="'required|alpha_spaces|max:40'"
              data-vv-as="Nombre"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('name')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('name') }}</div>
        </div>
        <div class="form-group col-md-4" :class="{ 'has-error': errors.has('lastname'), 'has-success' : fields.lastname && fields.lastname.valid }">
          <float-label>
            <input
              type="text"
              name="lastname"
              id="lastname"
              class="form-control efecto"
              placeholder="Apellido"
              v-model="user.apellido"
              v-validate="'required|alpha_spaces|max:80'"
              data-vv-as="Apellido"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('lastname')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('lastname') }}</div>
        </div>
        <div class="form-group col-md-4" :class="{'has-error' : errors.has('dni'), 'has-success' : fields.dni && fields.dni.valid }">
          <float-label>
            <input
              type="text"
              name="dni"
              id="dni"
              class="form-control efecto"
              placeholder="DNI"
              v-model="user.dni"
              v-validate="'required|numeric|max:12'"
              data-vv-as="DNI"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('dni')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('dni') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4" :class="{ 'has-error': errors.has('email'), 'has-success' : fields.email && fields.email.valid  }">
          <float-label>
            <input
              type="email"
              name="email"
              id="email"
              class="form-control efecto"
              placeholder="Email"
              v-model="user.email"
              v-validate="'required|email'"
              ref="email"
              data-vv-as="Email"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('email')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('email') }}</div>
        </div>
        <div class="form-group col-md-4" :class="{ 'has-error': errors.has('telefono'), 'has-success' : fields.telefono && fields.telefono.valid  }">
          <float-label>
            <input
              type="tel"
              name="telefono"
              id="telefono"
              class="form-control efecto"
              placeholder="Teléfono"
              v-model="user.telefono"
              v-validate="'required|numeric|max:11'"
              data-vv-as="Teléfono"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('telefono')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('telefono') }}</div>
        </div>
        <div class="form-group col-md-4" :class="{ 'has-error': errors.has('cuil'), 'has-success' : fields.cuil && fields.cuil.valid }" v-if="user.tipo == 'persona'">
          <float-label>
            <input
              type="text"
              name="cuil"
              id="cuil"
              class="form-control efecto"
              placeholder="CUIL"
              v-model="user.cuil"
              v-validate="user.tipo != 'empresa' ? 'required|numeric|max:11' : ''"
              data-vv-as="CUIL"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('cuil')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('cuil') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6" :class="{ 'has-error': errors.has('modelo'), 'has-success' : fields.modelo && fields.modelo.valid }">
          <float-label label="Producto de interés">
            <select
              name="model"
              id="model"
              class="form-control efecto"
              v-model="user.modelo_id"
              v-validate="'required'"
              data-vv-as="Producto de interés"
            >
              <option selected value="">Producto de interés</option>
              <option
                v-for="modelo in modelos"
                :key="modelo.id"
                :value="modelo.id"
              >{{ modelo.nombre }}</option>
            </select>
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('model')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('model') }}</div>
        </div>
      </div>
      <div class="row" v-if="user.tipo == 'empresa' && this.user.adicional == 'Menos de 5 unidades'">
        <span class="separador"></span>
        <div class="col-xs-12">
          <h3>Datos de la empresa</h3>
        </div>
        <div
          class="form-group col-md-6"
          :class="{'has-error' : errors.has('razon'), 'has-success' : fields.razon && fields.razon.valid }">
          <float-label>
            <input
              type="text"
              name="razon"
              id="razon"
              class="form-control efecto"
              placeholder="Empresa"
              v-model="user.razon"
              v-validate="user.tipo == 'empresa' ? 'max:140' : ''"
              data-vv-as="Empresa"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('razon')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('razon') }}</div>
        </div>
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('cargo'), 'has-success' : fields.cargo && fields.cargo.valid }" v-if="user.tipo == 'persona' || (user.tipo == 'empresa' && this.user.adicional == 'Menos de 5 unidades')">
          <float-label>
            <input
              type="text"
              name="cargo"
              id="cargo"
              class="form-control efecto"
              placeholder="Cargo"
              v-model="user.cargo"
              v-validate="'max:50'"
              data-vv-as="Cargo"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('cargo')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('cargo') }}</div>
        </div>
        <div
          class="form-group col-md-6"
          :class="{ 'has-error': errors.has('cuit'), 'has-success' : fields.cuit && fields.cuit.valid }" v-if="user.tipo == 'empresa' && this.user.adicional == 'Menos de 5 unidades'">
          <float-label>
            <input
              type="text"
              name="cuit"
              id="cuit"
              class="form-control efecto"
              placeholder="CUIT"
              v-model="user.cuit"
              v-validate="user.tipo == 'empresa' ? 'numeric|max:11' : ''"
              data-vv-as="CUIT"
            >
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('cuit')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('cuit') }}</div>
        </div>
      </div>  
      <div class="row">
        <span class="separador"></span>
        <div class="col-xs-12">
          <h3>Escoge tu concesionario</h3>
        </div>
        <div class="form-group col-md-6">
          <float-label label="Provincia">
            <select
              name="provincia"
              id="provincia"
              class="form-control efecto"
              placeholder="Provincia"
              v-model="user.provincia"
              data-vv-as="Provincia"
            >
              <option selected value>Provincia</option>
              <option
                v-for="provincia in provincias"
                :key="provincia"
                :value="provincia"
              >{{provincia}}</option>
            </select>
            <span class="focus-border"></span>
          </float-label>
        </div>
        <div class="form-group col-md-6">
          <float-label label="Concesionario">
            <select
              name="concesionaria_id"
              id="concesionaria"
              class="form-control efecto"
              placeholder="Concesionario"
              v-model="user.concesionaria_id"
              v-validate="'required'"
              data-vv-as="Concesionario"
            >
              <option selected value>Concesionario</option>
              <option v-if="Object.keys(select).length"
                v-for="concesionaria in select"
                :key="concesionaria.id"
                :value="concesionaria.id"
              >{{ concesionaria.nombre_completo }}</option>
              <option v-else>Elegir provincia primero</option>
            </select>
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('concesionaria_id')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('concesionaria_id') }}</div>
        </div>
      </div>
      <div class="row">
        <span class="separador"></span>
        <div class="col-xs-12">
          <h3>Comentarios</h3>
        </div>
        <div class="form-group col-xs-12">
          <float-label>
            <textarea name="comentarios"
              id="comentarios"
              class="form-control efecto"
              placeholder="Comentarios"
              v-model="user.comentarios"
              v-validate="'max:200'"
              data-vv-as="Comentarios"></textarea>
            <span class="focus-border"></span>
          </float-label>
          <div
            v-if="errors.has('comentarios')"
            class="animated headShake bg-danger text-danger"
          >{{ errors.first('comentarios') }}</div>
        </div>
      </div>
      <div class="row">
        <span class="separador3"></span>
        <div class="col-xs-12">
          <h3>Mantenete al día</h3>
        </div>
        <div class="col-xs-12">
          <h4>¿Te gustaría recibir descuentos y novedades de Volkswagen?</h4>
          <div class="checkboxes">
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  id="newsletter"
                  name="newsletter"
                  data-vv-as="Newsletter"
                  v-model="user.newsletter"
                > <span class="checkbox-custom"></span>Sí
              </label>
            </div>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                > <span class="checkbox-custom"></span>No
              </label>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <button type="submit" class="btn btn-default btn-primary" :disabled="cargando || errors.any()"><span v-text="cargando ? 'Enviando' : 'Enviar'"></span></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import FloatLabel from "vue-float-label/components/FloatLabel";

export default {
  name: "Form",
  components: {
    FloatLabel
  },
  props: ["modelos", "concesionarias"],
  data() {
    return {
      cargando: false,
      user: {
        tipo: "empresa",
        razon: "",
        cuit: "",
        cuil: "",
        nombre: "",
        apellido: "",
        telefono: "",
        dni: "",
        email: "",
        modelo_id: "",
        concesionaria_id: "",
        newsletter: false,
        provincia: "",
        comentarios: "",
        adicional: "Menos de 5 unidades"
      },
      select_concesionarias: [],
      submitted: false,
      API_URL: "https://institucional.vwcontenidos.com.ar/api"
    };
  },
  watch: {
    "user.tipo": function() {
      if(this.user.tipo === 'empresa')
        this.user.adicional = 'Menos de 5 unidades'
      else
        this.user.adicional = 'Persona con discapacidad'
    },
    "user.provincia": function(val) {
      if (val !== "") {
        this.select_concesionarias = this.concesionarias[val];
      }
    }
  },
  computed: {
    select: function() {
      if(this.select_concesionarias.length < 1)
        return []
      return this.select_concesionarias.map(function(c) {
        c['nombre_completo'] = c['nombre']+' ('+c["localidad"]+' - '+ c["direccion"]+')'
        return c
      })
    },
    provincias: function() {
      return Object.keys(this.concesionarias).sort((a, b) =>
        a.localeCompare(b)
      );
    },
    modelo: function() {
      let self = this;
      return this.modelos.find(modelo => modelo.id === self.user.modelo_id);
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.cargando = true;
          let form_data = new FormData();
          let item = this.user;

          for (let key in item) {
            form_data.append(key, item[key]);
          }

          // (window.smartSignals2 = window.smartSignals2 || []).push({
          //   event: "FormSubmissionCustomerService",
          //   payload: {
          //     leadInformation: {
          //       version: "1.0",
          //       leadType: "6",
          //       formName: this.motivo.smart,
          //       productName: this.modelo ? this.modelo.modelo : null
          //     }
          //   }
          // });
          axios
            .post(this.API_URL+'/ventas-corporativas', form_data, {
              headers: {
                "Content-type": "application/x-www-form-urlencoded"
              }
            })
            .then(res => {
              this.cargando = false;
              if (res.status === 200) {
                swal({
                  type: "success",
                  text: res.data,
                  confirmButtonText: "Volver",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  onAfterClose: function() {
                    window.location = "https://www.volkswagen.com.ar/es.html";
                  }
                });
              } else {
                swal({
                  type: "error",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  text:
                    "Ocurrió un error, por favor intente nuevamente más tarde."
                });
              }
            })
            .catch(() => {
              swal({
                type: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
                text:
                  "Ocurrió un error, por favor intente nuevamente más tarde."
              });
            });
        } else {
          document.querySelector('#scroll').scrollIntoView({ 
            behavior: 'smooth' 
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  transition: all 0.3s ease;
}

.text-danger {
  padding: 0.5em;
  border-radius: 4px;
}

textarea {
  min-width: 100%;
  max-width: 100%;
}

form {
  padding-top: 1.1em;
  & > .row.margin {
    margin-bottom: 6.7em;
  }
  & > .row:not(.margin) {
    margin-bottom: 0.8em;
  }
  h3 {
    font-size: 2.3em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    font-weight: 200;
    letter-spacing: -0.04em;
    margin-bottom: 1.55em;
  }
  input,
  select,
  textarea {
    color: #001e50;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    box-shadow: none;
    border-radius: 0;
    font-size: 1.2em;
    padding: 0;
    letter-spacing: -0.035em;
    &:hover,
    &:focus {
      box-shadow: none;
    }
    &:focus {
      outline: none;
      border-color: #9b9b9b;
    }
    &.efecto ~ .focus-border {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 1px;
      background-color: #001e50;
      transition: 0.4s;
    }
    &.efecto:focus ~ .focus-border {
      width: 100%;
      transition: 0.4s;
      left: 0;
    }
  }
  select {
    -webkit-appearance: none;
    appearance: none;
  }
  textarea {
    resize: none;
    margin-top: 0.3em;
    height: 1.6em;
  }
  .separador,
  .separador2,
  .separador3 {
    display: block;
    height: 1.4em;
  }
  .separador2 {
    height: 7.3em;
  }
  .separador3 {
    height: 6em;
  }
  #legal {
    margin-top: 6.7em;
    font-size: 1.4em;
    line-height: 1.3em;
    letter-spacing: -0.022em;
    font-weight: 200;
  }
  h4 {
    font-size: 1.45em;
    margin-top: 0.3em;
    letter-spacing: -0.005em;
    margin-bottom: 0.1em;
    @media (max-width: 669px) {
      font-size: 1.6em;
    }
  }
  .checkbox {
    color: #001e50;
    font-size: 1.4em;
    margin-top: 2.1em;
    @media (max-width: 669px) {
      font-size: 1.8em;
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    label {
      padding-left: 2em;
      vertical-align: text-bottom;
      line-height: 0.6em;
      letter-spacing: -0.007em;
      @media (max-width: 1441px) {
        line-height: 1.4em;
      }
      @media (max-width: 669px) {
        line-height: 0.3em;
      }
    }
    .checkbox-custom {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 24px;
      width: 24px;
      background-color: transparent;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      border: 2px solid #001e50;
      border-radius: 0;
    }
    input:checked ~ .checkbox-custom {
      background-color: #001e50;
      -webkit-transform: rotate(0deg) scale(1);
      -ms-transform: rotate(0deg) scale(1);
      transform: rotate(0deg) scale(1);
      opacity: 1;
      border: 2px solid #001e50;
    }
    .checkbox-custom::after {
      position: absolute;
      content: "";
      left: 12px;
      top: 12px;
      height: 0px;
      width: 0px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(0deg) scale(0);
      -ms-transform: rotate(0deg) scale(0);
      transform: rotate(0deg) scale(0);
      opacity: 1;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }
    input:checked ~ .checkbox-custom::after {
      -webkit-transform: rotate(45deg) scale(1);
      -ms-transform: rotate(45deg) scale(1);
      transform: rotate(45deg) scale(1);
      opacity: 1;
      left: 8px;
      top: 3px;
      width: 6px;
      height: 12px;
      border: solid white;
      border-width: 0 2px 2px 0;
      background-color: transparent;
      border-radius: 0;
    }
  }
  .btn.btn-primary {
    border-radius: 22px;
    margin: 8.2em 0;
    font-size: 1.2em;
    padding: 0.4em 2.8em 0.6em;
    letter-spacing: -0.04em;
    color: #fff;
    background: #001e50;
    border: 1px solid #fff;
    &:focus,
    &:active {
      box-shadow: none;
      outline: none;
    }
    @media (max-width: 669px) {
      display: block;
      width: 100%;
      font-size: 1.4em;
      padding: 0.6em;
      margin: 2em 0;
    }
  }
  .relative {
    position: relative;
  }
  .has-success .form-control,
  .has-success .form-control:focus,
  .has-error .form-control,
  .has-error .form-control:focus {
    box-shadow: none;
    border-color: #9b9b9b;
  }

  .text-danger {
    background: white;
    color: #dd2c00;
    padding: 2px;
  }

  .checkbox {
    display: inline-block;
    margin-right: 2em;
  }

  .opciones {
    margin: 2.5em 0 1em;
    &.horizontal {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .radio {
        display: flex;
        margin-top: 0;
        margin-right: 75px;
        label {
          padding-left: 0;
        }
      }
    }
  }
}
@supports(-webkit-appearance: none) or (-moz-appearance: none) {
  input[type='radio'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 21px;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    cursor: pointer;
    border: 2px solid #001e50;
    background: white;
    transition: background .3s, border-color .3s, box-shadow .2s;
    &:after {
      content: '';
      display: block;
      left: 0;
      top: 0;
      position: absolute;
      transition: transform var(--d-t, .3s) var(--d-t-e, ease), opacity var(--d-o, .2s);
      background: #001e50;
    }
    &:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: .3s;
      --d-t: .6s;
      --d-t-e: cubic-bezier(.2, .85, .32, 1.2);
    }
    &:disabled {
      --b: var(--disabled);
      cursor: not-allowed;
      opacity: .9;
      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }
      & + label {
        cursor: not-allowed;
      }
    }
    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          --bc: var(--border-hover);
        }
      }
    }
    &:not(.switch) {
      width: 21px;
      margin-right: 10px;
      &:after {
        opacity: var(--o, 0);
      }
      &:checked {
        --o: 1;
      }
    }
    & + label {
      font-size: 1.2em;
      line-height: 1.4em;
      display: inline-block;
      cursor: pointer;
      margin-left: 4px;
      font-weight: 400;
      @media(max-width: 767px) {
        font-size: 2em;
      }
    }
  }
  .radio {
    display: flex;
    align-items: center;
    margin-bottom: 2.2em;
    @media (max-width: 767px) {
      &.fix {
        display: block;
        input {
          float: left;
          margin-top: 4px;
        }
      }
    }
  }
  input[type='radio'] {
    outline: none;
    box-shadow: none;
    border-radius: 50%;
    &:after {
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background: var(--active-inner);
      opacity: 0;
      transform: scale(var(--s, .7));
      background: #001e50;
    }
    &:checked {
      --s: .5;
    }
  }
}
</style>
